module.exports = __webpack_public_path__ + "static/custom_template_in_template_list-409815b592f63d5d476787d2a5aa87e2.png";